import { render, staticRenderFns } from "./NotificationsMenu.vue?vue&type=template&id=09aff342&scoped=true"
import script from "./NotificationsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./NotificationsMenu.vue?vue&type=style&index=0&id=09aff342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09aff342",
  null
  
)

export default component.exports